import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { AngularFileUploaderComponent } from './angular-file-uploader.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  declarations: [AngularFileUploaderComponent],
  exports: [AngularFileUploaderComponent]
})
export class AngularFileUploaderModule { }
